
import * as api from "../constant/NewAPI";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import React, { useEffect, useState } from "react";
import Utils from "../constant/Utils";
import Select from "react-select";
import { Link } from "react-router-dom";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "react-bootstrap";
import Swal from "sweetalert2";

// import * as api from "../constant/API";

const Stock = () => {

    const [searchInput, setSearchInput] = useState("");
    const [stockList, setStockList] = useState([]);
    const [sportList, setSportList] = useState([]);
    const [productList, setProductList] = useState([]);
    const [vendorList, setVendorList] = useState([]);
    const [stcSze, setStcSze] = useState("");
    const [qty, setQty] = useState("");
    const [price, setPrice] = useState("");
    const [stkDate, setStkDate] = useState("");
    const [sportId, setSportId] = useState("");
    const [prdctId, setPrdctId] = useState("");
    const [vndrId, setVndrId] = useState("");
    const [stkId, setStkId] = useState("");
    const [avilQty, setAvilQty] = useState("");

    const [addSportId, setAddSportId] = useState("");
    const [addPrdctId, setAddPrdctId] = useState("");
    const [addVndrId, setAddVndrId] = useState("");
    const [addStcSze, setAddStcSze] = useState("");
    const [addQty, setAddQty] = useState("");
    const [addPrice, setAddPrice] = useState("");
    const [addStkDate, setAddStkDate] = useState("");
    const [openModal, setOpenModal] = useState(false);
    const [openStockModal, setOpenStockModal] = useState(false);
    const [isEdit, setIsEdit] = useState(false);

    const roleId = localStorage.getItem("RoleId");

    useEffect(() => {
        stkList(null);
        if (roleId == '1' || roleId == '3') {
            sportsList();
        }
    }, [])

    function stkList(id: string | null) {
        let getStockList = api.StockList;
        if (id) {
            getStockList += '/' + id
        }
        fetch(getStockList, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((stkResponse) => stkResponse.json())
            .then((stkResult) => {
                if (stkResult.code == 401) {
                    Utils.logoutUser();
                }
                if (id) {
                    setStkId(stkResult.data[0].stockId)
                    setSportId(stkResult.data[0].stockSportId)
                    prdctList(stkResult.data[0].stockSportId)
                    setPrdctId(stkResult.data[0].stockProductId)
                    setVndrId(stkResult.data[0].stockVendorId)
                    setStcSze(stkResult.data[0].stockSize)
                    setQty(stkResult.data[0].stockQuantity)
                    setPrice(stkResult.data[0].stockPrice)
                    setStkDate(stkResult.data[0].stockAddDate)
                }
                else {
                    setStockList(stkResult.data)
                    setInitial();
                }
            })
            .catch((error) => {
                console.log("Failed to fetch stock list", error)
            })
    }

    function sportsList() {
        const getSportsList = api.InventorySportList;
        fetch(getSportsList, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((sprtResponse) => sprtResponse.json())
            .then((sprtResult) => {
                if (sprtResult.error == false) {
                    setSportList(sprtResult.data)
                } else {
                    if (sprtResult.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire(sprtResult.message)
                }
            })
    }

    function prdctList(sprtid) {
        const getProdList = api.productsBySportsId + "/" + sprtid;
        fetch(getProdList, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((prodResponse) => prodResponse.json())
            .then((prodResult) => {
                if (prodResult.error == false) {
                    setProductList(prodResult.data)
                } else {
                    if (prodResult.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire(prodResult.message)
                }
            })
            .catch((error) => {
                console.log("Failed to fetch product list", error)
            })
    }


    function vendrList(prdtid) {
        const getVendorList = api.VendorByProduct + '/' + prdtid;
        fetch(getVendorList, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((vendResponse) => vendResponse.json())
            .then((vendResult) => {
                // console.log(Array.isArray(vendResult.data));

                if (vendResult.error == false) {
                    setVendorList(vendResult.data)
                } else {
                    if (vendResult.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire(vendResult.message)
                }
            })
            .catch((error) => {
                console.log("Failed to fetch vendor list", error);
            })
    }

    function setInitial() {
        setStkId('')
        setSportId('')
        setPrdctId('')
        setVndrId('')
        setStcSze('')
        setQty('')
        setPrice('')
        setStkDate('')
    }

    function editStock(rowData) {
        const stokId = rowData.stockId;
        // setStkId(stokId);
        stkList(stokId);
        setIsEdit(true)
        setOpenModal(true)
    }

    function saveStock() {
        if (isEdit) {
            updateStock()
        } else {
            const formData = new FormData();
            formData.append('stockProductUpdate', prdctId)
            formData.append('stockVendorUpdate', vndrId)
            formData.append('stockQtyUpdate', qty)
            const updateStkQty = api.UpdateStockQuantity;
            fetch(updateStkQty, {
                method: "POST",
                headers: {
                    "Authorization": 'Bearer ' + Utils.getAccessToken()
                },
                body: formData
            })
                .then((response) => response.json())
                .then((result) => {
                    if (result.error == false) {
                        Swal.fire({
                            title: 'Success',
                            text: result.message,
                            confirmButtonText: 'OK',
                            allowOutsideClick: false,
                            allowEscapeKey: false
                        }).then((res) => {
                            if (res.isConfirmed) {
                                window.location.reload(); // 🔁 Reload only after OK is clicked
                            }
                        });
                    } else {
                        if (result.code == 401) {
                            Utils.logoutUser();
                        }
                        Swal.fire({
                            title: 'Error',
                            text: result.message,
                            confirmButtonText: 'OK',
                            allowOutsideClick: false,
                            allowEscapeKey: false
                        }).then((res) => {
                            if (res.isConfirmed) {
                                window.location.reload(); // 🔁 Reload only after OK is clicked
                            }
                        });
                    }
                })
        }
        setOpenModal(false)
    }

    function updateStock() {
        const formData = new FormData();
        formData.append('stockIdEdit', stkId)
        formData.append('stockSportEdit', sportId)
        formData.append('stockProductEdit', prdctId)
        formData.append('stockVendorEdit', vndrId)
        formData.append('stockSizeEdit', stcSze)
        formData.append('stockQtyEdit', qty)
        formData.append('stockPriceEdit', price)
        formData.append('stockDateEdit', stkDate)
        const updateStk = api.UpdateStock;
        fetch(updateStk, {
            method: "POST",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
            body: formData
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                }
            })
    }

    function addStock() {
        const formData = new FormData();
        formData.append('stockSport', addSportId);
        formData.append('stockProduct', addPrdctId);
        formData.append('stockVendor', addVndrId);
        formData.append('stockSize', addStcSze);
        formData.append('stockQty', addQty);
        formData.append('stockPrice', addPrice);
        formData.append('stockDate', addStkDate);
        const createstock = api.CreateStock;
        fetch(createstock, {
            method: "POST",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
            body: formData
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                }
            })
        setOpenStockModal(false)
    }

    const filteredData = stockList.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value !== null && value !== undefined ? value.toString().toLowerCase() : '');
        return values.some((value) => value.includes(searchInput.toLowerCase()));
    });

    const slNoRender = (rowData, column) => {
        return column.rowIndex + 1;
    };

    const productRender = (rowData) => {
        return <span>{rowData.ProductName}</span>;
    };

    const vendorRender = (rowData) => {
        return <span>{rowData.VendorName}</span>;
    };

    const sizeRender = (rowData) => {
        return <span>{rowData.stockSize}</span>;
    };

    const quantityRender = (rowData) => {
        return <span>{rowData.stockQuantity}</span>;
    };

    const priceRender = (rowData) => {
        return <span>{rowData.stockPrice}</span>;
    };

    const editDetails = (rowData) => {
        return (
            <Link to="#" onClick={() => editStock(rowData)}>
                <i className="feather-edit"></i>Edit
            </Link>
        );
    };


    return (
        <>
            <div className="row">
                <div className="col-sm-12">
                    <div className="court-tab-content">
                        <div className="card card-tableset">
                            <div className="card-body">
                                <div className="coache-head-blk">
                                    <div className="row align-items-center">
                                        {roleId == '1' || roleId == '3' ? (
                                            <>
                                                <div className="row col-lg-12">
                                                    <div className="col-lg-6">
                                                        <Button
                                                            className="btn-secondary me-3 text-uppercase"
                                                            variant="success"
                                                            onClick={() => setOpenStockModal(true)}
                                                        >
                                                            <i className="feather-plus" />&nbsp;
                                                            Add Stock
                                                        </Button>
                                                        <Button
                                                            className="btn-secondary text-uppercase"
                                                            variant="success"
                                                            onClick={() => { setOpenModal(true); setIsEdit(false); setInitial(); }}
                                                        >
                                                            <i className="fas fa-arrow-up" />&nbsp;
                                                            Update Stock
                                                        </Button>
                                                    </div>
                                                </div>
                                            </>
                                        ) : null}
                                        <div className="col-lg-6">
                                        </div>
                                        <div className="col-lg-6">
                                            <div className="dataTables_filter">
                                                <label>
                                                    <input
                                                        type="text"
                                                        value={searchInput}
                                                        onChange={(e) => setSearchInput(e.target.value)}
                                                        placeholder="Search"
                                                        className="form-control"
                                                    />
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="tab-content">
                                    <div
                                        className="tab-pane fade show active"
                                        id="nav-Recent"
                                        role="tabpanel"
                                        aria-labelledby="nav-Recent-tab"
                                        tabIndex={0}
                                    >
                                        <div className="table-responsive table-datatble">
                                            <DataTable
                                                className="table datatable"
                                                value={filteredData}
                                                paginator
                                                rows={10}
                                                rowsPerPageOptions={[10, 25, 50]}
                                                currentPageReportTemplate="{first}- {last} of {totalRecords} entries"
                                            >
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="slNo"
                                                    header="Sl No"
                                                    body={slNoRender}
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="ProductName"
                                                    header="Product"
                                                    body={productRender}
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="VendorName"
                                                    header="Vendor"
                                                    body={vendorRender}
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="stockSize"
                                                    header="Size"
                                                    body={sizeRender}
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="stockQuantity"
                                                    header="Quantity"
                                                    body={quantityRender}
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="stockPrice"
                                                    header="Price"
                                                    body={priceRender}
                                                ></Column>

                                                {(roleId == '1' || roleId == '3') ? (
                                                    <Column
                                                        className="text-link"
                                                        body={editDetails}
                                                    ></Column>
                                                ) : null}
                                            </DataTable>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {
                <Modal
                    show={openModal}
                    size="md"
                    centered
                    onHide={() => setOpenModal(false)}
                >
                    <ModalHeader>
                        <ModalTitle>
                            <h4 className="mb-0 upper-case"><i className="fas fa-plus" />{isEdit ? "Edit " : "Update "}Stock</h4>
                        </ModalTitle>
                        <Button
                            variant=""
                            className="btn-close"
                            onClick={() => setOpenModal(false)}
                        ></Button>
                    </ModalHeader>
                    <ModalBody>
                        <div className="col-lg-12 mb-10">
                            <label className="form-label">Sport</label>
                            <Select
                                value={sportList.find(sprt => sprt.sportId === sportId) ? {
                                    value: sportId,
                                    label: sportList.find(sprt => sprt.sportId === sportId).sportName
                                } : null}
                                onChange={(e) => {
                                    setSportId(e?.value)
                                    prdctList(e?.value)
                                }}
                                placeholder="Select a Sport"
                                options={sportList.map(sprt => ({
                                    value: sprt.sportId,
                                    label: sprt.sportName
                                }))}>
                            </Select>
                        </div>
                        <div className="col-lg-12 mb-10">
                            <label className="form-label">Product</label>
                            <Select
                                value={productList.find(prdct => prdct.productId === prdctId) ? {
                                    value: prdctId,
                                    label: productList.find(prdct => prdct.productId === prdctId).productName
                                } : null}
                                onChange={(e) => {
                                    setPrdctId(e?.value)
                                    vendrList(e?.value)
                                }}
                                placeholder="Select a Product"
                                options={productList.map(prdct => ({
                                    value: prdct.productId,
                                    label: prdct.productName
                                }))}>
                            </Select>
                        </div>
                        <div className="col-lg-12 mb-10">
                            <label className="form-label">Vendor</label>
                            <Select
                                value={
                                    Array.isArray(vendorList) && vendorList.find(vndr => vndr.vendorId === vndrId)
                                        ? {
                                            value: vndrId,
                                            label: vendorList.find(vndr => vndr.vendorId === vndrId)?.vendorName
                                        }
                                        : null
                                }
                                onChange={(e) => {
                                    setVndrId(e?.value);
                                }}
                                options={
                                    Array.isArray(vendorList)
                                        ? vendorList.map(vndr => ({
                                            value: vndr.vendorId,
                                            label: vndr.vendorName
                                        }))
                                        : []
                                }
                            />
                        </div>
                        {!isEdit &&
                            <>
                                <div className="col-lg-12 mb-10">
                                    <div className="input-space">
                                        <label className="form-label">Available Quantity</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                            id="availQty"
                                            disabled={!isEdit}
                                            value={avilQty}
                                            onChange={(e) => setAvilQty(e.target.value)}
                                            placeholder="Available Quantity" />
                                    </div>
                                </div>
                                <div className="col-lg-12 mb-10">
                                    <div className="input-space">
                                        <label className="form-label">New Quantity</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                            id="nwQty"
                                            value={qty}
                                            onChange={(e) => setQty(e.target.value)}
                                            placeholder="New Quantity" />
                                    </div>
                                </div>
                            </>
                        }
                        {isEdit &&
                            <>
                                <div className="col-lg-12 mb-10">
                                    <label className="form-label">Stock Size</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                        id="stksze"
                                        value={stcSze}
                                        onChange={(e) => setStcSze(e.target.value)}
                                    />
                                </div>
                                <div className="col-lg-12 mb-10">
                                    <label className="form-label">Quantity</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                        id="qty"
                                        value={qty}
                                        onChange={(e) => setQty(e.target.value)}
                                    />
                                </div>
                                <div className="col-lg-12 mb-10">
                                    <label className="form-label">Price</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                        id="price"
                                        value={price}
                                        onChange={(e) => setPrice(e.target.value)}
                                    />
                                </div>
                                <div className="col-lg-12 mb-10">
                                    <label className="form-label">Stock Date</label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                        id="stkdt"
                                        value={stkDate}
                                        onChange={(e) => setStkDate(e.target.value)}
                                    />
                                </div>
                            </>
                        }
                    </ModalBody>
                    <ModalFooter>
                        <Button
                            className="btn-primary text-uppercase"
                            variant="success"
                            onClick={() => { saveStock(); setOpenModal(false) }}
                            data-bs-dismiss="modal" aria-label="Close"
                        >
                            <b><i className="fas fa-save" />{isEdit ? " Update" : " Save"}</b>
                        </Button>
                    </ModalFooter>
                </Modal>
            }

            {
                <Modal
                    show={openStockModal}
                    size="xl"
                    centered
                    onHide={() => { setOpenStockModal(false) }}
                >
                    <ModalHeader>
                        <ModalTitle>
                            <h4 className="mb-0 text-uppercase text-center"><i className="fas fa-plus" />Add Stock</h4>
                        </ModalTitle>
                        <Button
                            variant=""
                            className="btn-close"
                            onClick={() => setOpenStockModal(false)}
                        ></Button>
                    </ModalHeader>
                    <ModalBody>
                        <div className="row">
                            <div className="col-lg-6 mb-10">
                                <label className="form-label">Sport</label>
                                <Select
                                    value={sportList.find(sprt => sprt.sportId === addSportId) ? {
                                        value: addSportId,
                                        label: sportList.find(sprt => sprt.sportId === addSportId).sportName
                                    } : null}
                                    onChange={(e) => {
                                        setAddSportId(e?.value)
                                        prdctList(e?.value)
                                    }}
                                    placeholder="Select a Sport"
                                    options={sportList.map(sprt => ({
                                        value: sprt.sportId,
                                        label: sprt.sportName
                                    }))}>
                                </Select>
                            </div>
                            <div className="col-lg-6 mb-10">
                                <label className="form-label">Product</label>
                                <Select
                                    value={productList.find(prdct => prdct.productId === addPrdctId) ? {
                                        value: addPrdctId,
                                        label: productList.find(prdct => prdct.productId === addPrdctId).productName
                                    } : null}
                                    onChange={(e) => {
                                        setAddPrdctId(e?.value);
                                        vendrList(e?.value)
                                    }}
                                    placeholder="Select a Product"
                                    options={productList.map(prdct => ({
                                        value: prdct.productId,
                                        label: prdct.productName
                                    }))}>
                                </Select>
                            </div>
                            <div className="col-lg-6 mb-10">
                                <label className="form-label">Vendor</label>
                                <Select
                                    value={
                                        Array.isArray(vendorList) && vendorList.find(vndr => vndr.vendorId === addVndrId)
                                            ? {
                                                value: addVndrId,
                                                label: vendorList.find(vndr => vndr.vendorId === addVndrId)?.vendorName
                                            }
                                            : null
                                    }
                                    onChange={(e) => {
                                        setAddVndrId(e?.value);
                                    }}
                                    options={
                                        Array.isArray(vendorList)
                                            ? vendorList.map(vndr => ({
                                                value: vndr.vendorId,
                                                label: vndr.vendorName
                                            }))
                                            : []
                                    }
                                />
                            </div>
                            <div className="col-lg-6 mb-10">
                                <label className="form-label">Stock Size</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                    id="stksze"
                                    value={addStcSze}
                                    onChange={(e) => setAddStcSze(e.target.value)}
                                    placeholder="Size"
                                />
                            </div>
                            <div className="col-lg-6 mb-10">
                                <label className="form-label">Quantity</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                    id="qty"
                                    value={addQty}
                                    onChange={(e) => setAddQty(e.target.value)}
                                    placeholder="Quantity"
                                />
                            </div>
                            <div className="col-lg-6 mb-10">
                                <label className="form-label">Price</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                    id="price"
                                    value={addPrice}
                                    onChange={(e) => setAddPrice(e.target.value)}
                                    placeholder="Price Per Unit"
                                />
                            </div>
                            <div className="col-lg-6 mb-10">
                                <label className="form-label">Stock Date</label>
                                <input
                                    type="date"
                                    className="form-control"
                                    style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                    id="stkdt"
                                    value={addStkDate}
                                    onChange={(e) => setAddStkDate(e.target.value)}
                                    placeholder="Stock Date"
                                />
                            </div>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <Button
                            className="btn-primary text-uppercase"
                            variant="success"
                            onClick={() => { addStock(); setOpenStockModal(false) }}
                            data-bs-dismiss="modal" aria-label="Close"
                        >
                            <b><i className="fas fa-save" /> Save</b>
                        </Button>
                    </ModalFooter>
                </Modal>
            }
        </>
    );
};

export default Stock;